import { connect } from 'react-redux'
import * as selector from '../../state/plan/selector'
import * as customerSelector from '../../../customer/state/detail/selector'
import * as action from '../../state/plan/action'
import TreatmentDuration from '../plan/TreatmentDuration'


const mapStateToProps = (state, props) => {
    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
        alignerSystemList: customerSelector.selectTreatmentAlignerSystemList(state),
        alignersPerStepList: selector.selectAlignersPerStepList(),
    }
}

const mapDispatchToProps = {
    changeTreatmentPlan: action.changeTreatmentPlan,
    saveTreatmentPlan: action.saveTreatmentPlan,
}


export default connect(mapStateToProps, mapDispatchToProps)(TreatmentDuration)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/TreatmentDurationWidgetContainer.js